/* ==========================================================================
   AURIQUE — Shared Preloader  (Shopify Edition)
   Loads BOTH the day-cream and night-cream frame sets together, under the
   single loader that lives at the top of the page (#ahLoader).

   Frame URLs are built from window.AURIQUE_FRAMES_BASE and
   window.AURIQUE_NIGHT_FRAMES_BASE — two globals that MUST be set by a
   <script> tag in the Liquid template BEFORE this file is loaded, e.g.:

     <script>
       window.AURIQUE_FRAMES_BASE      = "{{ 'aurique-frame-0001.jpg' | asset_url | split: 'aurique-frame-0001.jpg' | first }}";
       window.AURIQUE_NIGHT_FRAMES_BASE = "{{ 'aurique-night-0001.jpg' | asset_url | split: 'aurique-night-0001.jpg' | first }}";
     </script>

   Extra images (product jars, logos) are also loaded from Shopify CDN via
   window.AURIQUE_IMG_URLS — an object keyed by logical name, also injected
   by Liquid before this file runs.
   ========================================================================== */

(function () {
  "use strict";

  /* ── Scroll lock ── applied immediately so user cannot scroll until all
     frames and high-definition product images are 100% preloaded.           */
  document.documentElement.classList.add("ah-loading");

  var DAY_FRAME_COUNT = 100;
  var NIGHT_FRAME_COUNT = 170;
  var FRAME_PAD = 4;

  /* Bases injected by Liquid — fall back to relative paths if somehow absent
     (so the file still works if dropped into a plain HTML environment).      */
  var dayBase = (window.AURIQUE_FRAMES_BASE || "frames/frame-");
  var nightBase = (window.AURIQUE_NIGHT_FRAMES_BASE || "frames-night/frame-");

  // Parse query string (like ?v=1234567) so we don't insert the frame number after the query param
  var dayParts = dayBase.split('?');
  var dayBasePath = dayParts[0];
  var dayQuery = dayParts[1] ? ('?' + dayParts[1]) : '';

  var nightParts = nightBase.split('?');
  var nightBasePath = nightParts[0];
  var nightQuery = nightParts[1] ? ('?' + nightParts[1]) : '';

  /* Extra images: keyed URLs injected by Liquid, fall back to relative.     */
  var imgUrls = window.AURIQUE_IMG_URLS || {
    logoGold: "img/logo-gold.png",
    logo: "img/logo.png",
    hydration: "img/day.png",
    renewal: "img/night.png",
    hydraGlowHD: "img/AURIQUE_Hydra_Glow_HD.webp",
    rejuvenatePlusHD: "img/AURIQUE_Rejuvenate_Plus_HD.webp"
  };

  var EXTRA_URLS = Object.keys(imgUrls).map(function (k) { return imgUrls[k]; });

  var loader = document.getElementById("ahLoader");
  var loaderFill = document.getElementById("ahLoaderFill");
  var loaderPct = document.getElementById("ahLoaderPct");

  var totalAssets = DAY_FRAME_COUNT + NIGHT_FRAME_COUNT + EXTRA_URLS.length;
  var loadedAssets = 0;

  var dayImages = new Array(DAY_FRAME_COUNT);
  var nightImages = new Array(NIGHT_FRAME_COUNT);

  function pad(num, len) {
    var s = String(num);
    while (s.length < len) s = "0" + s;
    return s;
  }

  function dayFrameUrl(index) {
    return dayBasePath + pad(index + 1, FRAME_PAD) + ".jpg" + dayQuery;
  }

  function nightFrameUrl(index) {
    return nightBasePath + pad(index + 1, FRAME_PAD) + ".jpg" + nightQuery;
  }

  function onItemSettled() {
    loadedAssets++;
    var pct = Math.round((loadedAssets / totalAssets) * 100);
    if (loaderFill) loaderFill.style.width = pct + "%";
    if (loaderPct) loaderPct.textContent = pct + "%";
    if (loadedAssets >= totalAssets) onAllLoaded();
  }

  function preloadFrameSet(urlFn, target, count) {
    for (var i = 0; i < count; i++) {
      (function (idx) {
        var img = new Image();
        img.onload = img.onerror = function () {
          target[idx] = img;
          onItemSettled();
        };
        img.src = urlFn(idx);
      })(i);
    }
  }

  function preloadExtraImages() {
    for (var i = 0; i < EXTRA_URLS.length; i++) {
      (function (url) {
        var img = new Image();
        img.onload = img.onerror = function () { onItemSettled(); };
        img.src = url;
      })(EXTRA_URLS[i]);
    }
  }

  window.__auriqueFrames = {
    dayImages: dayImages,
    nightImages: nightImages,
    isReady: false
  };

  function dispatchReady() {
    window.__auriqueFrames.isReady = true;
    var detail = { dayImages: dayImages, nightImages: nightImages };
    var evt;
    if (typeof window.CustomEvent === "function") {
      evt = new CustomEvent("aurique:frames-ready", { detail: detail });
    } else {
      evt = document.createEvent("CustomEvent");
      evt.initCustomEvent("aurique:frames-ready", false, false, detail);
    }
    window.dispatchEvent(evt);
  }

  var isFinished = false;
  function onAllLoaded() {
    if (isFinished) return;
    isFinished = true;
    if (loader) loader.classList.add("is-done");
    dispatchReady();
    document.documentElement.classList.remove("ah-loading");
  }

  /* Safety fallback: ensure page is scrollable even on slow connections */
  setTimeout(function () {
    if (!isFinished) {
      console.warn("Aurique preloader timeout — forcing unlock.");
      onAllLoaded();
    }
  }, 7000);

  preloadFrameSet(dayFrameUrl, dayImages, DAY_FRAME_COUNT);
  preloadFrameSet(nightFrameUrl, nightImages, NIGHT_FRAME_COUNT);
  preloadExtraImages();
})();
